// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as PorterStoreIcons from "./PorterStoreIcons.bs.js";
import * as PorterStoreTypes from "../PorterStoreTypes.bs.js";
import * as PorterStoreHelpers from "../PorterStoreHelpers.bs.js";
import * as PorterStoreStrings from "../PorterStoreStrings.bs.js";
import * as PorterStoreStatusBadge from "./PorterStoreStatusBadge.bs.js";
import * as PorterStoreDownloadModal from "./PorterStoreDownloadModal.bs.js";
import * as PorterStoreFilterDropdown from "./PorterStoreFilterDropdown.bs.js";

function PorterStoreOrdersTable(Props) {
  var allOrders = Props.allOrders;
  var pendingCount = Props.pendingCount;
  var completedCount = Props.completedCount;
  var isLoading = Props.isLoading;
  var isLoadingMore = Props.isLoadingMore;
  var activeTab = Props.activeTab;
  var onTabChange = Props.onTabChange;
  var onOrderClick = Props.onOrderClick;
  var onScroll = Props.onScroll;
  var onSearch = Props.onSearch;
  var onClearSearch = Props.onClearSearch;
  var match = React.useState(function () {
        return "";
      });
  var setSearchInput = match[1];
  var searchInput = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowDownloadModal = match$1[1];
  var match$2 = React.useState(function () {
        return {
                selected: [],
                temp: [],
                isOpen: false
              };
      });
  var setStatusFilter = match$2[1];
  var statusFilter = match$2[0];
  var statusFilterRef = React.useRef(null);
  var match$3 = React.useState(function () {
        return {
                selected: [],
                temp: [],
                selectAll: false,
                tempSelectAll: false,
                isOpen: false
              };
      });
  var setCityFilter = match$3[1];
  var cityFilter = match$3[0];
  var cityFilterRef = React.useRef(null);
  var tabKey = activeTab ? "completed" : "in_progress";
  React.useEffect((function () {
          Curry._1(setSearchInput, (function (param) {
                  return "";
                }));
          Curry._1(setStatusFilter, (function (param) {
                  return {
                          selected: [],
                          temp: [],
                          isOpen: false
                        };
                }));
          Curry._1(setCityFilter, (function (param) {
                  return {
                          selected: [],
                          temp: [],
                          selectAll: false,
                          tempSelectAll: false,
                          isOpen: false
                        };
                }));
          
        }), [tabKey]);
  var filteredOrders = PorterStoreHelpers.filterOrders(allOrders, statusFilter.selected, cityFilter.selected);
  var handleSearchKeyDown = function ($$event) {
    if ($$event.key === "Enter") {
      return Curry._1(onSearch, searchInput);
    }
    
  };
  var statusFilterItems = Belt_Array.map(PorterStoreTypes.allOrderStatuses, (function (status) {
          var statusStr = PorterStoreTypes.orderStatusToString(status);
          return {
                  key: statusStr,
                  label: React.createElement(PorterStoreStatusBadge.make, {
                        status: status
                      }),
                  checked: Belt_Array.some(statusFilter.temp, (function (s) {
                          return s === status;
                        }))
                };
        }));
  var handleStatusToggle = function (key) {
    return Curry._1(setStatusFilter, (function (prev) {
                  var status = Belt_Array.getBy(PorterStoreTypes.allOrderStatuses, (function (s) {
                          return PorterStoreTypes.orderStatusToString(s) === key;
                        }));
                  var newTemp = status !== undefined ? (
                      Belt_Array.some(prev.temp, (function (p) {
                              return p === status;
                            })) ? Belt_Array.keep(prev.temp, (function (p) {
                                return p !== status;
                              })) : Belt_Array.concat(prev.temp, [status])
                    ) : prev.temp;
                  return {
                          selected: prev.selected,
                          temp: newTemp,
                          isOpen: prev.isOpen
                        };
                }));
  };
  var handleStatusApply = function (param) {
    return Curry._1(setStatusFilter, (function (prev) {
                  return {
                          selected: prev.temp,
                          temp: prev.temp,
                          isOpen: prev.isOpen
                        };
                }));
  };
  var selectAllItem_label = React.createElement("span", {
        className: "ps-filter-city-label ps-filter-city-label--bold"
      }, PorterStoreStrings.selectAllCities);
  var selectAllItem_checked = cityFilter.tempSelectAll;
  var selectAllItem = {
    key: "select_all",
    label: selectAllItem_label,
    checked: selectAllItem_checked
  };
  var cityItems = Belt_Array.map(PorterStoreTypes.allCities, (function (city) {
          return {
                  key: city,
                  label: React.createElement("span", {
                        className: "ps-filter-city-label"
                      }, city),
                  checked: Belt_Array.some(cityFilter.temp, (function (c) {
                          return c === city;
                        }))
                };
        }));
  var cityFilterItems = Belt_Array.concat([selectAllItem], cityItems);
  var handleCityToggle = function (key) {
    if (key === "select_all") {
      return Curry._1(setCityFilter, (function (prev) {
                    var newVal = !prev.tempSelectAll;
                    return {
                            selected: prev.selected,
                            temp: newVal ? PorterStoreTypes.allCities : [],
                            selectAll: prev.selectAll,
                            tempSelectAll: newVal,
                            isOpen: prev.isOpen
                          };
                  }));
    } else {
      return Curry._1(setCityFilter, (function (prev) {
                    var newCities = Belt_Array.some(prev.temp, (function (c) {
                            return c === key;
                          })) ? Belt_Array.keep(prev.temp, (function (c) {
                              return c !== key;
                            })) : Belt_Array.concat(prev.temp, [key]);
                    var allSelected = newCities.length === PorterStoreTypes.allCities.length;
                    return {
                            selected: prev.selected,
                            temp: newCities,
                            selectAll: prev.selectAll,
                            tempSelectAll: allSelected,
                            isOpen: prev.isOpen
                          };
                  }));
    }
  };
  var handleCityApply = function (param) {
    return Curry._1(setCityFilter, (function (prev) {
                  return {
                          selected: prev.temp,
                          temp: prev.temp,
                          selectAll: prev.tempSelectAll,
                          tempSelectAll: prev.tempSelectAll,
                          isOpen: prev.isOpen
                        };
                }));
  };
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "ps-header"
                }, React.createElement("div", {
                      className: "ps-header__nav"
                    }, React.createElement("div", {
                          className: "ps-header__title-section"
                        }, React.createElement(PorterStoreIcons.Home.make, {}), React.createElement("div", {
                              className: "ps-header__title-wrapper"
                            }, React.createElement("span", {
                                  className: "ps-header__title"
                                }, PorterStoreStrings.pageTitle))), React.createElement("div", {
                          className: "ps-header__tabs"
                        }, React.createElement("div", {
                              className: activeTab === /* InProgress */0 ? "ps-tab ps-tab--active" : "ps-tab",
                              onClick: (function (param) {
                                  return Curry._1(onTabChange, /* InProgress */0);
                                })
                            }, React.createElement("span", {
                                  className: "ps-tab__label"
                                }, PorterStoreStrings.tabInProgress), React.createElement("span", {
                                  className: "ps-tab__badge ps-tab__badge--blue"
                                }, String(pendingCount))), React.createElement("div", {
                              className: activeTab === /* Completed */1 ? "ps-tab ps-tab--active" : "ps-tab",
                              onClick: (function (param) {
                                  return Curry._1(onTabChange, /* Completed */1);
                                })
                            }, React.createElement("span", {
                                  className: "ps-tab__label"
                                }, PorterStoreStrings.tabCompleted), React.createElement("span", {
                                  className: "ps-tab__badge ps-tab__badge--blue"
                                }, String(completedCount)))))), React.createElement("div", {
                  className: "ps-toolbar"
                }, React.createElement("div", {
                      className: "ps-search"
                    }, React.createElement("div", {
                          className: "ps-search__input-wrapper"
                        }, React.createElement("span", {
                              className: "ps-search__icon"
                            }, React.createElement(PorterStoreIcons.Search.make, {})), React.createElement("input", {
                              className: "ps-search__input",
                              placeholder: PorterStoreStrings.searchPlaceholder,
                              type: "text",
                              value: searchInput,
                              onKeyDown: handleSearchKeyDown,
                              onChange: (function ($$event) {
                                  var value = $$event.target.value;
                                  return Curry._1(setSearchInput, (function (param) {
                                                return value;
                                              }));
                                })
                            }), searchInput !== "" ? React.createElement("span", {
                                className: "ps-search__clear",
                                onClick: (function (param) {
                                    Curry._1(setSearchInput, (function (param) {
                                            return "";
                                          }));
                                    return Curry._1(onClearSearch, undefined);
                                  })
                              }, React.createElement(PorterStoreIcons.SearchClear.make, {})) : null), React.createElement("button", {
                          className: "ps-search__btn",
                          onClick: (function (param) {
                              return Curry._1(onSearch, searchInput);
                            })
                        }, PorterStoreStrings.searchPlaceholder)), activeTab === /* InProgress */0 ? React.createElement("button", {
                        className: "ps-download-btn",
                        onClick: (function (param) {
                            return Curry._1(setShowDownloadModal, (function (param) {
                                          return true;
                                        }));
                          })
                      }, React.createElement(PorterStoreIcons.Download.make, {}), React.createElement("span", undefined, PorterStoreStrings.downloadCsv)) : null), React.createElement("div", {
                  className: "ps-table-container",
                  onScroll: onScroll
                }, React.createElement("div", {
                      className: "ps-table-card"
                    }, React.createElement("table", {
                          className: "ps-table"
                        }, React.createElement("thead", undefined, React.createElement("tr", {
                                  className: "ps-table__header-row"
                                }, React.createElement("th", {
                                      className: "ps-table__th ps-table__th--order"
                                    }, PorterStoreStrings.headerOrderDetails), React.createElement("th", {
                                      className: "ps-table__th ps-table__th--status"
                                    }, React.createElement("div", {
                                          ref: statusFilterRef,
                                          className: "ps-table__th-filter",
                                          onClick: (function (param) {
                                              Curry._1(setStatusFilter, (function (prev) {
                                                      return {
                                                              selected: prev.selected,
                                                              temp: prev.selected,
                                                              isOpen: !prev.isOpen
                                                            };
                                                    }));
                                              return Curry._1(setCityFilter, (function (prev) {
                                                            return {
                                                                    selected: prev.selected,
                                                                    temp: prev.temp,
                                                                    selectAll: prev.selectAll,
                                                                    tempSelectAll: prev.tempSelectAll,
                                                                    isOpen: false
                                                                  };
                                                          }));
                                            })
                                        }, React.createElement("span", undefined, PorterStoreStrings.headerOrderStatus), React.createElement(PorterStoreIcons.Filter.make, {})), React.createElement("div", {
                                          className: "ps-table__th-filter-anchor"
                                        }, React.createElement(PorterStoreFilterDropdown.make, {
                                              items: statusFilterItems,
                                              onToggle: handleStatusToggle,
                                              onApply: handleStatusApply,
                                              anchorRef: statusFilterRef,
                                              onClose: (function (param) {
                                                  return Curry._1(setStatusFilter, (function (prev) {
                                                                return {
                                                                        selected: prev.selected,
                                                                        temp: prev.temp,
                                                                        isOpen: false
                                                                      };
                                                              }));
                                                }),
                                              isOpen: statusFilter.isOpen
                                            }))), React.createElement("th", {
                                      className: "ps-table__th ps-table__th--partner"
                                    }, PorterStoreStrings.headerPartnerName), React.createElement("th", {
                                      className: "ps-table__th ps-table__th--city"
                                    }, React.createElement("div", {
                                          ref: cityFilterRef,
                                          className: "ps-table__th-filter",
                                          onClick: (function (param) {
                                              Curry._1(setCityFilter, (function (prev) {
                                                      return {
                                                              selected: prev.selected,
                                                              temp: prev.selected,
                                                              selectAll: prev.selectAll,
                                                              tempSelectAll: prev.selectAll,
                                                              isOpen: !prev.isOpen
                                                            };
                                                    }));
                                              return Curry._1(setStatusFilter, (function (prev) {
                                                            return {
                                                                    selected: prev.selected,
                                                                    temp: prev.temp,
                                                                    isOpen: false
                                                                  };
                                                          }));
                                            })
                                        }, React.createElement("span", undefined, PorterStoreStrings.headerCity), React.createElement(PorterStoreIcons.Filter.make, {})), React.createElement("div", {
                                          className: "ps-table__th-filter-anchor"
                                        }, React.createElement(PorterStoreFilterDropdown.make, {
                                              items: cityFilterItems,
                                              onToggle: handleCityToggle,
                                              onApply: handleCityApply,
                                              anchorRef: cityFilterRef,
                                              onClose: (function (param) {
                                                  return Curry._1(setCityFilter, (function (prev) {
                                                                return {
                                                                        selected: prev.selected,
                                                                        temp: prev.temp,
                                                                        selectAll: prev.selectAll,
                                                                        tempSelectAll: prev.tempSelectAll,
                                                                        isOpen: false
                                                                      };
                                                              }));
                                                }),
                                              isOpen: cityFilter.isOpen
                                            }))), React.createElement("th", {
                                      className: "ps-table__th ps-table__th--phone"
                                    }, PorterStoreStrings.headerPhoneNumber))), React.createElement("tbody", undefined, isLoading ? React.createElement("tr", undefined, React.createElement("td", {
                                        className: "ps-table__td",
                                        colSpan: 5
                                      }, React.createElement("div", {
                                            className: "ps-empty-state"
                                          }, React.createElement("span", {
                                                className: "ps-empty-state__title"
                                              }, PorterStoreStrings.loadingOrders)))) : (
                                filteredOrders.length !== 0 ? Belt_Array.map(filteredOrders, (function (order) {
                                          return React.createElement("tr", {
                                                      key: order.orderId,
                                                      className: "ps-table__row ps-table__row--clickable",
                                                      onClick: (function (param) {
                                                          return Curry._1(onOrderClick, order);
                                                        })
                                                    }, React.createElement("td", {
                                                          className: "ps-table__td ps-table__td--order"
                                                        }, React.createElement("div", {
                                                              className: "ps-order-details"
                                                            }, React.createElement("span", {
                                                                  className: "ps-order-details__id"
                                                                }, order.orderId), React.createElement("span", {
                                                                  className: "ps-order-details__date"
                                                                }, PorterStoreStrings.createdOnPrefix + PorterStoreTypes.formatDate(order.createdOn)))), React.createElement("td", {
                                                          className: "ps-table__td ps-table__td--status"
                                                        }, React.createElement(PorterStoreStatusBadge.make, {
                                                              status: order.orderStatus
                                                            })), React.createElement("td", {
                                                          className: "ps-table__td"
                                                        }, order.partnerName), React.createElement("td", {
                                                          className: "ps-table__td"
                                                        }, order.city), React.createElement("td", {
                                                          className: "ps-table__td"
                                                        }, order.phoneNumber));
                                        })) : React.createElement("tr", undefined, React.createElement("td", {
                                            className: "ps-table__td",
                                            colSpan: 5
                                          }, React.createElement("div", {
                                                className: "ps-empty-state"
                                              }, React.createElement(PorterStoreIcons.EmptyDocument.make, {}), React.createElement("span", {
                                                    className: "ps-empty-state__title"
                                                  }, PorterStoreStrings.noOrdersFound), React.createElement("span", {
                                                    className: "ps-empty-state__desc"
                                                  }, PorterStoreStrings.noOrdersDescription))))
                              ), isLoadingMore ? React.createElement("tr", undefined, React.createElement("td", {
                                        className: "ps-table__td",
                                        colSpan: 5
                                      }, React.createElement("div", {
                                            className: "ps-table__loading-more"
                                          }, PorterStoreStrings.loadingMoreOrders))) : null)))), React.createElement(PorterStoreDownloadModal.make, {
                  isOpen: match$1[0],
                  onClose: (function (param) {
                      return Curry._1(setShowDownloadModal, (function (param) {
                                    return false;
                                  }));
                    }),
                  onDownload: (function (param) {
                      return PorterStoreHelpers.downloadCsv(filteredOrders);
                    })
                }));
}

var make = PorterStoreOrdersTable;

export {
  make ,
  
}
/* react Not a pure module */
